import React from "react";
import PropTypes from "prop-types";
import { component_tool } from "@/tool";
import { AudienceGroupItem } from '@/components';
import WizTableForm from "../wizTableForm/wizTableForm";
import "./style/index.less";

const { WizComponent, WizModal, WizRow, WizCol, WizRadio, WizAlert, WizForm } = component_tool;

class WizAuthority extends WizComponent {
  componentName = "WizAuthority";

  constructor(props) {
    super(props);
    this.state = {
      initRows: {},
      visible: props.visible,
      defaultCheckValue: !props.hasRadioGroup ? 0 : 1,
      time: new Date().getTime(),
      scope: {},
      visibleForGroup: false
    };
  }

  _initRows = (props) => {
    if (this.flag) return;

    const { value = {}, keys } = props || this.props;
    const initRows = {};
    const types = ["orgIds", "positionIds", "positionCategoryIds", "personIds"];
    let defaultCheckValue = null
    types.forEach((key) => {
      if (keys.includes(key)) {
        if (value && value[key] && value[key].length) {
          initRows[key] = value[key];
          defaultCheckValue = 0
        } else {
          initRows[key] = [];
        }
      }
    });

    if (value.groupId) {
      initRows.groupId = Array.isArray(value.groupId) ? value.groupId : [value.groupId]
      defaultCheckValue = 1
    } else {
      initRows.groupId = []
    }

    this.setState({
      time: new Date().getTime(),
      initRows,
      defaultCheckValue: defaultCheckValue === null ? 1 : defaultCheckValue
    })
  }

  componentWillMount() {
    this.flag = false
    this._initRows()
  }

  propsAndStateOnChange = {
    visible: this._visibleOnChange.bind(this),
    value: this._value.bind(this),
  };

  _visibleOnChange(nextProps, nextState) {
    if (nextProps.visible !== this.props.visible) {
      nextState.visible = nextProps.visible;
    }
    return true;
  }

  _value(nextProps, nextState) {
    this._initRows(nextProps, false)
    this.flag = false
    return true;
  }

  _getRowValue = (type, value = {}) => {
    switch (type) {
      case "org":
        return {
          title: "组织选择：",
          values: value.orgIds || [],
        };
      case "position":
        return { title: "岗位选择：", values: value.positionIds || [] };
      case "positionCategory":
        return { title: "岗位分类：", values: value.positionCategoryIds || [] };
      case "groupId":
        return { title: "组：", values: value && value.groupId ? (Array.isArray(value.groupId) ? value.groupId : [value.groupId]) : [] };

    }
    return { title: "", values: [] };
  };

  _renderAudienceRow = (type, value) => {
    let rowValue = this._getRowValue(type, value);
    console.log(rowValue, 'rowValuerowValue')
    let result = rowValue.values.map((val, index) => {
      return <span key={index} className="info-item">
        {val.positionBrandName ? val.positionBrandName : val.name}
      </span>

    });
    console.log(result, 'resultresult')
    return result.length ? (
      <div className="item-row">
        <div className="audience-row-title">{rowValue.title}</div>
        <div className="audience-row-body">{result}</div>
      </div>
    ) : null;
  };

  _renderAudienceBlock = (value) => {
    let audienceRows = [];
    let { keys, showBlock } = this.props;
    if (keys.includes("orgIds")) {
      audienceRows.push(this._renderAudienceRow("org", value));
    }
    if (keys.includes("positionCategoryIds")) {
      audienceRows.push(this._renderAudienceRow("positionCategory", value));
    }
    if (keys.includes("positionIds")) {
      audienceRows.push(this._renderAudienceRow("position", value));
    }
    if (keys.includes("groupId")) {
      audienceRows.push(this._renderAudienceRow("groupId", value));
    }
    if (audienceRows.length) {
      if (!showBlock) {
        return audienceRows;
      }
      return (
        <div className="block-item">
          <WizRow type="flex" justify="center">
            <WizCol span={3} className="item-title">
              {"受众范围："}
            </WizCol>
            <WizCol span={18}>
              <div className="item-body">{audienceRows}</div>
            </WizCol>
          </WizRow>
        </div>
      );
    }
  };

  _renderPersonBlock = (value) => {
    let { keys, showBlock } = this.props;
    if (keys.includes("personIds")) {
      let personValue = value.personIds || [];
      let result = personValue.map((val, index) => (
        <span key={index} className="info-item">
          {val.userName}({val.fullName})
        </span>
      ));
      if (!showBlock) {
        return result.length ? (
          <div className="item-row">
            <div className="audience-row-title">{"指定人员："}</div>
            <div className="audience-row-body">{result}</div>
          </div>
        ) : null;
      }
      return (
        <div className="block-item">
          <WizRow type="flex" justify="center">
            <WizCol span={3} className="item-title">
              {"指定人员："}
            </WizCol>
            <WizCol span={18}>
              <div className="item-body">
                <div className="item-row">{result}</div>
              </div>
            </WizCol>
          </WizRow>
        </div>
      );
    }
  };

  _renderMessage = (value) => {
    let { keys } = this.props;
    if (keys.includes("message") && value.message && value.message.length) {
      let message = value.message.map((val, index) => (
        <div key={index} className="message-item">
          {val}
        </div>
      ));
      return (
        <div className="block-item">
          <WizRow type="flex" justify="center">
            <WizCol span={18}>
              <WizAlert message={message} type="info" showIcon />
            </WizCol>
          </WizRow>
        </div>
      );
    }
  };

  _renderShow = () => {
    let { value = {} } = this.props;
    console.log(value, 'value777')
    return (
      <div className="authority-show">
        {this._renderAudienceBlock(value)}
        {this._renderPersonBlock(value)}
        {this._renderMessage(value)}
      </div>
    );
  };

  handleButtonClick = () => {
    const { value = {} } = this.props;
    this.setState({ visible: !this.state.visible });
  };

  _renderButton = () => {
    return (
      <div className="authority-button">
        <a onClick={this.handleButtonClick}>查看受众</a>
        <WizModal
          visible={this.state.visible}
          title="查看受众"
          width={800}
          footer={null}
          onCancel={this._onCancel}
          {...this.props.modal}
        >
          {this._renderShow()}
        </WizModal>
      </div>
    );
  };

  // 查看受众
  handleLook = (e, text) => {
    e.stopPropagation()
    this.setState({ visibleForGroup: true, scope: text })
  }

  _column = (type) => {
    const { initRows } = this.state;
    // let { initRows } = init;

    let { keyConfig } = this.props;
    let title, placeholder;
    let config;
    if (keyConfig && keyConfig[type]) {
      title = keyConfig[type]["title"];
      config = keyConfig[type]["config"];
    } else if (type === "orgIds") {
      title = "组织选择";
      placeholder = "请选择组织";
      config = WizTableForm.Config.organization(this, {
        apiParams: { state: 1 },
      });
    } else if (type === "positionCategoryIds") {
      title = "岗位分类";
      placeholder = "请选择岗位分类";
      config = WizTableForm.Config.positionCategory(this, {
        apiParams: { state: 1 },
      });
    } else if (type === "positionIds") {
      title = "岗位选择";
      placeholder = "请选择岗位";
      config = WizTableForm.Config.position(this, { apiParams: { state: 1 } });
    } else if (type === "personIds") {
      title = "指定人员";
      placeholder = "请选择指定人员";
      config = WizTableForm.Config.user(this, { apiParams: { state: 1 } });
    } else if (type === "groupId") {
      title = "选择组";
      placeholder = "请选择组";
      config = {
        selectType: 'radio',
        ...WizTableForm.Config.audienceGroup(this, { apiParams: { state: 1 } })
      }
    } else {
      return false;
    }

    let column = {
      title,
      name: type,
      formItem: {
        diy: WizTableForm,
        initRows: initRows[type],
        onChangeRowMap: (e) => this._selectOnChange(type, e),
        placeholder,
        ...config,
      },
    };

    return column;
  };

  _columns = () => {
    const { defaultCheckValue } = this.state;
    let columns = [];
    if (defaultCheckValue && this.props.hasRadioGroup) {
      let column = this._column('groupId');
      columns.push(column)
      return columns
    }
    let { keys } = this.props;
    keys && keys.length && keys.forEach((key) => {
      let column = this._column(key);
      column && columns.push(column);
    });
    return columns;
  };

  _selectOnChange = (key, e) => {
    const { initRows, defaultCheckValue } = this.state;
    const { hasRadioGroup } = this.props
    const values = Object.values(e);
    initRows[key] = values || [];
    this.setState({ initRows, time: new Date().getTime() });
    const { mode, onChange } = this.props;
    if (mode === "Form" && onChange) {
      const _data = {}
      if (hasRadioGroup && defaultCheckValue === 1) {
        const _groupId = initRows.groupId[0] || {}
        const groupScope = _groupId.groupScope
        if (groupScope === undefined) {
          _data.groupId = []
        } else {
          delete groupScope.isAll;
          delete _groupId.groupScope;
          groupScope.groupId = [_groupId]
          _data.groupId = groupScope.groupId
        }
        this.setState({ initRows: groupScope || [], time: new Date().getTime() })
      } else {
        _data.orgIds = initRows.orgIds
        _data.positionIds = initRows.positionIds
        _data.positionCategoryIds = initRows.positionCategoryIds
        _data.personIds = initRows.personIds
      }
      this.flag = true
      onChange(_data);
    }
  };

  handleCheckboxOnChange = (e) => {
    this.setState({ defaultCheckValue: e.target.value, time: new Date().getTime() });
  };

  _renderForm = () => {
    const { formPropsExtra, hasRadioGroup } = this.props;
    const { defaultCheckValue, initRows, time, scope, visibleForGroup } = this.state;
    const initKeys = {}
    for (let item in initRows) {
      initKeys[item] = initRows[item].map(val => val.id)
    }
    const formProps = {
      key: time,
      ref: "form",
      columns: this._columns(),
      className: "authority-form-wrp",
      record: initKeys,
      footer: () => null,
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 15 },
      },
      style: { marginTop: 15, paddingTop: 24, border: "1px solid #eee" },
      ...formPropsExtra,
    };

    const modalProps = {
      title: '查看受众组',
      visible: visibleForGroup,
      footer: null,
      onCancel: () => {
        this.setState({ visibleForGroup: false })
      }
    }

    return (
      <React.Fragment>
        {hasRadioGroup ? (
          <WizRadio.Group
            key={defaultCheckValue}
            onChange={this.handleCheckboxOnChange}
            defaultValue={defaultCheckValue}
          >
            <WizRadio value={1}>组</WizRadio>
            <WizRadio value={0}>自主选择</WizRadio>
          </WizRadio.Group>
        ) : null}

        <WizForm {...formProps} />

        <WizModal {...modalProps}>
          <AudienceGroupItem {...scope} />
        </WizModal>
      </React.Fragment>
    );
  };

  _onClick = () => {
    !this.state.visible && this.setState({ visible: true });
  };

  _onSubmit = (e) => {
    const { onChange, onSubmit } = this.props;
    const { initRows } = this.state;
    onChange && onChange(initRows);
    onSubmit && onSubmit(initRows);
    this._onClose();
  };

  _onCancel = (e) => {
    this._onClose();
  };

  _onClose = () => {
    this.state.visible && this.setState({ visible: false });
  };

  _renderComponent = () => {
    return (
      <>
        <div className="authority" onClick={() => this._onClick()}>
          {this._renderShow()}
        </div>
        <WizModal
          visible={this.state.visible}
          maskClosable={false}
          title="受众设置"
          width={800}
          onOk={this._onSubmit}
          onCancel={this._onCancel}
          {...this.props.modal}
        >
          {this._renderForm()}
        </WizModal>
      </>
    );
  };

  render() {
    let render = "_render" + this.props.mode;
    return <div className={this.props.classname}>{this[render]()}</div>;
  }
}

WizAuthority.defaultProps = {
  keys: [
    "orgIds",
    "positionIds",
    "positionCategoryIds",
    "personIds",
    "message",
    "groupId",
  ],
  // value: {},
  mode: "Form",
  showBlock: false,
  visible: false,
  hasRadioGroup: true,
  modal: {},
  keyConfig: {},
};

WizAuthority.propTypes = {
  keys: PropTypes.array,
  /**
   *  {
   *      orgIds: [ { id, name } ],
   *      positionIds: [ { id, name } ],
   *      positionCategoryIds: [ { id, name } ],
   *      personIds: [ { id, userName, fullName } ],
   *      message: [ ...string ]
   *  }
   */
  // value: PropTypes.object,
  mode: PropTypes.oneOf(["Component", "Form", "Show", "Button"]),
  formPropsExtra: PropTypes.object,
  showBlock: PropTypes.bool,
  visible: PropTypes.bool,
  modal: PropTypes.object,
  hasRadioGroup: PropTypes.bool,
  keyConfig: PropTypes.object, //keys对应的WizTableForm的config
};

export default WizAuthority;
